import {Container, DisplayObject, Sprite} from 'pixi.js';
import {DisplayObjectUtils, IAnimation, MovieClip} from '@gongxigames/framework/core';
import {AutomationMeta, AUTOMATION_META} from '@gongxigames/framework/slot/fragments/Autotest';

export enum RubyFrameIndex {
    normal = 1,
    activated
}

export class ReelSymbol extends Sprite {
    protected _index = 0;
    protected _reelSetIndex = 0;
    protected _trailAnimation?: IAnimation;
    protected _animationContainer?: Container;
    protected _trailAnimationContainer!: Container;
    protected _symbol!: Container;
    protected _symbolType = 0;
    protected _blurredContainer!: Container;
    protected _rubySymbol?: number;

    public init(parentSym: Sprite): void {
        this.addChild(parentSym);
        this._symbol = parentSym;

        if (!this._blurredContainer) {
            this._blurredContainer = new Container();
            this._symbol.addChild(this._blurredContainer);
        }

        (this as any)[AUTOMATION_META] = () => {
            const meta: AutomationMeta = {
                type: 'reels_symbol',
                id: this._symbolType,
                indexReel: this._reelSetIndex,
                indexSymbol: this._index
            };

            return meta;
        };
    }

    public setSymbol(symbolID: number): void {
        if (this._rubySymbol && symbolID !== this._rubySymbol) {
            this.stopTrailAnimation();
        }

        this.hideSymbol();
        this._symbol.getChildAt(symbolID).visible = true;
        this._blurredContainer.removeChildren();
        this._symbolType = symbolID;
    }

    public setSymbolFrameIndex(symbolFrameNumber: number, symbolType: number): void {
        const symbolMC = (this.symbol.children[symbolType] as Sprite).getChildByName('bg');

        symbolMC && (symbolMC as MovieClip).gotoAndStop(symbolFrameNumber);
    }

    public hideSymbol(): void {
        for (let i = 0; i < this._symbol.children.length; i++) {
            this._symbol.getChildAt(i).visible = false;
        }
    }

    public addBlur(): void {
        const blurredSymbol = DisplayObjectUtils.getBlurredSpriteFromCache(this._symbolType);

        if (blurredSymbol) {
            this.hideSymbol();

            blurredSymbol.anchor.set(0.5);

            this._blurredContainer.addChild(blurredSymbol);
            this._blurredContainer.visible = true;
        }
    }

    public removeBlur(): void {
        this._symbol.getChildAt(this._symbolType).visible = true;
        this._blurredContainer.removeChildren();
    }

    public stopTrailAnimation(): void {
        if (this._trailAnimation) {
            this._trailAnimation.stop();
            this._trailAnimation = undefined;

            this.trailAnimationContainer && this.trailAnimationContainer.removeChildren();
        }
    }

    public updateAnimationContainerPosition(): void {
        if (this.animationContainer) {
            this.animationContainer.x = this.x;
            this.animationContainer.y = this.y;
        }

        if (this.trailAnimationContainer) {
            this.trailAnimationContainer.x = this.x;
            this.trailAnimationContainer.y = this.y;
        }
    }

    public get trailAnimation(): IAnimation {
        return this._trailAnimation!;
    }

    public set trailAnimation(value: IAnimation) {
        this._trailAnimation = value;
    }

    public set index(value: number) {
        this._index = value;
    }

    public get index(): number {
        return this._index;
    }

    public get symbol(): Container {
        return this._symbol;
    }

    public get visibleSymbol(): DisplayObject {
        return this.symbol.getChildAt(this._symbolType);
    }

    public get animationContainer(): Container | undefined {
        return this._animationContainer;
    }

    public set animationContainer(value: Container | undefined) {
        this._animationContainer = value;
    }

    public get symbolType(): number {
        return this._symbolType;
    }

    public get reelSetIndex(): number {
        return this._reelSetIndex;
    }

    public set reelSetIndex(value: number) {
        this._reelSetIndex = value;
    }

    public get rubySymbol(): number {
        return this._rubySymbol!;
    }

    public set rubySymbol(value: number) {
        this._rubySymbol = value;
    }

    public get trailAnimationContainer(): Container {
        return this._trailAnimationContainer;
    }

    public set trailAnimationContainer(value: Container) {
        this._trailAnimationContainer = value;
    }
}
